package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.Character
import fr.manyverse.app.domain.model.CharacterToUpdate
import fr.manyverse.app.domain.repository.CharacterRepository
import fr.manyverse.app.domain.validation.CharacterValidator

class UpdateCharacterUseCase(
    private val characterRepository: CharacterRepository
) {
    suspend operator fun invoke(
        characterId: String,
        name: String,
        story: String,
        imageUrl: String? = null
    ): Result<Character> {
        CharacterValidator.validateForUpdate(
            characterId = characterId,
            name = name
        ).onFailure { return Result.failure(it) }

        val character = CharacterToUpdate(
            name = name,
            story = story,
            imageUrl = imageUrl
        )

        return characterRepository.updateCharacter(characterId, character)
    }
}
